import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import useSearch from "hooks/useSearch";
import { Link } from "react-router-dom";
import { searchByProp } from "utils/search";
import { FETCH_SUPPLIERS_WITH_PRODUCT_PRICE } from "./graphql";

const CostSuppliersPage = () => {
  const { loading, error, data } = useQuery(FETCH_SUPPLIERS_WITH_PRODUCT_PRICE);
  const [q, setQ] = useSearch();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const suppliers = data.suppliers.filter((i) => searchByProp(i, ["name"], q));

  return (
    <div className="p-6 flex-1 overflow-auto flex flex-col">
      <div>
        <SearchBar
          value={q}
          onChange={setQ}
          placeholder="Search supplier by name"
        />
      </div>

      <div className="flex-1 card mt-6 p-0 overflow-auto flex flex-col">
        <div className="flex-1 overflow-auto relative">
          <table>
            <tbody>
              {suppliers.map((supplier) => (
                <tr
                  key={supplier.id}
                  className="border-b border-gray-100 dark:border-gray-700"
                >
                  <td className="px-4">
                    <Link to={supplier.id}>{supplier.name || " - "}</Link>
                    {supplier.odooCompanies.length > 0 ? (
                      <span className="pl-3">
                        ({supplier.odooCompanies.join(", ")})
                      </span>
                    ) : (
                      "-"
                    )}
                    <span className="pl-2 opacity-70">#{supplier.id}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {suppliers.length === 0 ? (
            <div className="p-8 text-sm text-gray-500">No suppliers found.</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CostSuppliersPage;
